/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Popover } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  maintainCheckErrorMessageAction,
  maintainCheckFormErrorAction,
  maintainCheckReqAction,
} from '../../../Maintain/Check/store/actions';
import ErrorPopup from '../../NDC/component/ErrorPopup';
import { setViewCheckAllocationDetails } from '../../../Tasks/ViewCheckAllocation/store/actions';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { setClickOnMaintainCheckVal } from '../store/action';

const DisplayCheckActionComponent = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const handleClose = () => {
    setAnchor(null);
  };
  const id = open ? 'simple-popover' : undefined;

  const navigateToPage = (pathName, value) => {
    let updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    setAnchor(null);

    history.push({
      pathname: pathName,
    });
  };

  const handleAction = (val) => {
    dispatch(setViewCheckAllocationDetails(val));
    redirectURLLink(
      '/checkAllocDetail',
      'Check Alloc Detail',
      history,
      dispatch
    );
  };

  return (
    <div
      className="tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center"
      style={{ top: 0 }}
    >
      <div
        style={{ height: 'max-content' }}
        onClick={(e) => {
          setAnchor(e.currentTarget);
        }}
      >
        <SVGComponent iconName="Export-icon" />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchor}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <div className="d-flex flex-column py-2">
          <span
            className="dropdown-item"
            onClick={() => {
              handleAction(props.data);
            }}
          >
            Go to Check Allocation
          </span>
          <span
            className="dropdown-item"
            onClick={() => {
              dispatch(maintainCheckReqAction({}));
              dispatch(maintainCheckErrorMessageAction([]));
              dispatch(maintainCheckFormErrorAction({}));
              dispatch(setClickOnMaintainCheckVal(true));
              window.localStorage.setItem(
                'checkSearchValues',
                JSON.stringify(props.data)
              );
              navigateToPage('/maintain-check', 'Maintain Check');
            }}
          >
            Go to Maintain check
          </span>
        </div>
      </Popover>
      <ErrorPopup
        modalTitle="Display Check List"
        errorPopupMessage={error}
        onClose={() => setError(null)}
      />
    </div>
  );
};

export default DisplayCheckActionComponent;
